/*
  AdminClaimDisapproveModal
*/

import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { withApollo } from 'react-apollo';
import { connectModal as reduxModal } from 'redux-modal';

import TextField from 'ui/common/form/fields/text-field';
import validator from 'ui/common/form/validator';
import SubmitButton from 'ui/common/form/submit-button';
import fields, { fieldNames } from './model';
import messages from './messages';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'ui/common/modal';
import { disapproveClaim } from 'store/features/admin/claims/actions';
import { selectIsDisapprovingClaim } from 'store/features/admin/claims/selectors';
import { bindActionCreators } from 'redux';

const validate = validator(fields);

const { request: disapproveClaimRequest } = disapproveClaim;

export const MODAL_NAME = 'admin-claim-disapprove-modal';
export const FORM_NAME = 'admin-claim-disapprove-form';

class AdminClaimDisapproveModal extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  onSubmit(values) {
    const { claimId, disapproveClaimRequest } = this.props;
    const { disapprovalReason } = values;
    disapproveClaimRequest({ claimId, disapprovalReason });
  }

  render() {
    const {
      show,
      handleHide,
      handleSubmit,
      isDisapprovingClaim,
      intl: { formatMessage },
    } = this.props;

    return (
      <Modal isOpen={show}>
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <ModalHeader toggle={handleHide}>
            <p>{formatMessage(messages.modalTitle)}</p>
          </ModalHeader>
          <ModalBody>
            <Field
              name={fieldNames.disapprovalReason}
              component={TextField}
              multiLine
              rows={5}
              label={formatMessage(messages[fieldNames.disapprovalReason])}
            />
          </ModalBody>
          <ModalFooter className="float-right">
            <SubmitButton size="md" formName={FORM_NAME} loading={isDisapprovingClaim}>
              {formatMessage(messages.submitButton)}
            </SubmitButton>
          </ModalFooter>
        </form>
      </Modal>
    );
  }
}

function mapStateToProps(state, props) {
  const { claimId } = props;
  return {
    isDisapprovingClaim: selectIsDisapprovingClaim(state, { claimId }),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    disapproveClaimRequest: bindActionCreators(disapproveClaimRequest, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxModal({
    name: MODAL_NAME,
  })(
    reduxForm({
      form: FORM_NAME,
      validate,
    })(injectIntl(withApollo(AdminClaimDisapproveModal)))
  )
);



// WEBPACK FOOTER //
// ./src/ui/admin/claims/AdminClaimDisapproveModal/index.js